import { TimesheetStyle } from './globalStyles/timesheets';

export const TimesheetsTabStyles = () => {
  return (
    <>
      <TimesheetStyle />
    </>
  );
};
